"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const google_1 = require("@react-oauth/google");
const react_1 = require("react");
const react_cookie_1 = require("react-cookie");
const config_1 = require("config");
const purple_rose_png_1 = __importDefault(require("images/purple-rose.png"));
const internal_portal_components_1 = require("internal-portal-components");
const Routes_1 = __importDefault(require("./Routes"));
function App() {
    (0, react_1.useEffect)(() => {
        const favicon = document.querySelector("link[rel~='icon']");
        const title = document.getElementsByTagName('title')[0];
        if (favicon) {
            favicon.href = purple_rose_png_1.default;
        }
        if (title) {
            title.innerHTML = 'Internal Portal';
        }
    }, []);
    return ((0, jsx_runtime_1.jsxs)(google_1.GoogleOAuthProvider, { clientId: config_1.REACT_APP_INTERNAL_PORTAL_GOOGLE_CLIENT_ID, children: [(0, jsx_runtime_1.jsx)(internal_portal_components_1.ToastShell, {}), (0, jsx_runtime_1.jsx)(react_cookie_1.CookiesProvider, { children: (0, jsx_runtime_1.jsx)(Routes_1.default, {}) })] }));
}
exports.default = App;
